export default __webpack_public_path__ + "static/media/map2.bb77d22a.png";